import { environment } from '../environments/environment';

export class AppSettings {
	public static appName = environment.appName;
	public static authLogoUrl = environment.authLogoUrl;
	public static serviceRootUrl = environment.serviceRootUrl;
	public static esriServiceRootUrl = environment.esriServiceRootUrl;
	public static rootLink = environment.rootLink;
	public static idleTime = environment.idleTime;
	// Only production has this prop
	public static appRoot = environment.appRoot;
	// Feature toggles from config file
	public static featureToggleConfig = environment.featureToggle;

	public static envName = environment.envName;

	public static giveRoot = environment.giveRoot;

	// appNames
	public static a3iAppName = 'A3I';
	public static hpmsAppName = 'HPMS';
	public static lbeAppName = 'LBE';
	public static ninjaAppName = 'ENJ';
}



// WEBPACK FOOTER //
// ./src/app/app.settings.ts